function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTimeWaitFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8h-2v9.659l7.606 3.26.788-1.838L17 16.341V8z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.195 27.67c.898.216 1.837.33 2.805.33v2c-1.126 0-2.22-.134-3.27-.385l.465-1.944zm6.074 1.945c-1.05.251-2.143.385-3.269.385v-2c.968 0 1.907-.114 2.805-.33l.464 1.945zm8.67-6.3a14.072 14.072 0 01-4.624 4.623l-1.046-1.704a12.074 12.074 0 003.965-3.965l1.704 1.046zM30 16c0 1.126-.134 2.22-.385 3.269l-1.944-.464c.215-.898.329-1.837.329-2.805 0-.968-.114-1.907-.33-2.805l1.945-.465c.251 1.05.385 2.144.385 3.27zM23.315 4.06a14.072 14.072 0 014.623 4.624L26.235 9.73a12.073 12.073 0 00-3.965-3.964l1.046-1.705zM16 2c1.125 0 2.22.133 3.269.384l-.464 1.945A12.04 12.04 0 0016 4c-.968 0-1.907.114-2.805.33l-.465-1.946A14.037 14.037 0 0116 2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4C9.373 4 4 9.373 4 16c0 4.53 2.512 8.473 6.218 10.516l-1.025 1.72C4.903 25.842 2 21.26 2 16 2 8.268 8.268 2 16 2v2z",
    fill: props.color
  }));
}

export default SvgIconTimeWaitFilled;